import { LEASE_LOGIN } from '~/legacy/consts'

export const redirectOn401 = (response) => {
  if (response && response.status === 401) {
    window.location.replace(
      `${LEASE_LOGIN}?redirect=${encodeURIComponent(location.pathname)}`
    )
  }
}
